
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class Expandable extends Vue {
    @Prop() expanded! : boolean
    @Prop() label! : string

    expandedState: boolean = false

    beforeMount () {
      this.expandedState = this.expanded
    }

    onClick () {
      this.expandedState = !this.expandedState

      if (this.expandedState) {
        this.$emit('expand')
      } else {
        this.$emit('collapse')
      }
    }

    get cssClasses () {
      return {
        'pf-c-expandable-section': true,
        'pf-m-expanded': this.expandedState
      }
    }
}
